export default __webpack_public_path__ + "static/media/icon-profile.49254222.svg";